import { Injectable, Type } from '@angular/core';
import { GridSizeRules } from './dashboard.types';


// Register widget components here (or via provide/DI in a feature module)
@Injectable({ providedIn: 'root' })
export class DashboardRegistry {
  private registry = new Map<string, { component: Type<any>, title: string, rules?: GridSizeRules }>();

  register(key: string, component: Type<any>, title: string, rules?: GridSizeRules) {
    this.registry.set(key, { component, title, rules });
  }

  rules(key: string) { return this.registry.get(key)?.rules; }


  getComponent(key: string) { return this.registry.get(key)?.component; }
  getTitle(key: string) { return this.registry.get(key)?.title ?? key; }
  all() { return Array.from(this.registry.entries()).map(([type, v]) => ({ type, title: v.title })); }
}
